export default {
  apiUrl: 'https://staging.api.litroz.com',
  ftnUrl: 'https://www.receitaws.com.br/v1/cnpj',
  states: [
    { id: 'AC', name: 'AC' },
    { id: 'AL', name: 'AL' },
    { id: 'AP', name: 'AP' },
    { id: 'AM', name: 'AM' },
    { id: 'BA', name: 'BA' },
    { id: 'CE', name: 'CE' },
    { id: 'DF', name: 'DF' },
    { id: 'ES', name: 'ES' },
    { id: 'GO', name: 'GO' },
    { id: 'MA', name: 'MA' },
    { id: 'MT', name: 'MT' },
    { id: 'MS', name: 'MS' },
    { id: 'MG', name: 'MG' },
    { id: 'PA', name: 'PA' },
    { id: 'PB', name: 'PB' },
    { id: 'PR', name: 'PR' },
    { id: 'PE', name: 'PE' },
    { id: 'PI', name: 'PI' },
    { id: 'RJ', name: 'RJ' },
    { id: 'RN', name: 'RN' },
    { id: 'RS', name: 'RS' },
    { id: 'RO', name: 'RO' },
    { id: 'RR', name: 'RR' },
    { id: 'SC', name: 'SC' },
    { id: 'SP', name: 'SP' },
    { id: 'SE', name: 'SE' },
    { id: 'TO', name: 'TO' }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/constants.js